<template>
  <v-menu
    v-if="isAltindafirsat"
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    left
    nudge-bottom="8"
    min-width="360"
    max-width="420"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-badge
          :value="count > 0"
          :content="count"
          color="red"
          overlap
        >
          <v-icon :class="{ 'bell-pulse': count > 0 }" :color="count > 0 ? 'red' : ''">
            notifications
          </v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense flat color="amber darken-3" dark>
        <v-icon left>handshake</v-icon>
        <v-toolbar-title class="subheading">Vade Bildirimleri</v-toolbar-title>
        <v-spacer />
        <v-chip v-if="count > 0" small color="white" text-color="red darken-2">
          {{ count }}
        </v-chip>
      </v-toolbar>

      <v-list v-if="items.length > 0" two-line dense class="py-0" style="max-height: 380px; overflow-y: auto;">
        <template v-for="(n, i) in items">
          <v-list-tile :key="n.id" @click="goToPending(n)">
            <v-list-tile-avatar>
              <v-icon :color="severityColor(n.severity)">{{ severityIcon(n.severity) }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">
                {{ n.companyName }}
                <span class="caption grey--text">· {{ formatCurrency(n.agreedAmount || n.totalNetCash) }}</span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span :class="severityTextClass(n.severity)">{{ severityLabel(n) }}</span>
                · {{ formatDate(n.paymentDate) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="i < items.length - 1" :key="'d-' + n.id" />
        </template>
      </v-list>

      <v-card-text v-else class="text-xs-center grey--text py-4">
        <v-icon large color="grey lighten-1">check_circle_outline</v-icon>
        <div class="mt-2">Vadesi yaklaşan anlaşma yok</div>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn flat small color="amber darken-3" @click="goToPending()">
          Tümünü Gör
          <v-icon right small>arrow_forward</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'MintNotificationBell',
  data() {
    return {
      menu: false,
      pollHandle: null,
    };
  },
  computed: {
    isAltindafirsat() {
      const t = parseInt(localStorage.getItem('selectedTenantId') || '0', 10);
      return t === 1;
    },
    notifications() {
      return this.$store.getters['mintAgreements/notifications'] || { count: 0, items: [] };
    },
    count() {
      return this.notifications.count || 0;
    },
    items() {
      return this.notifications.items || [];
    },
  },
  mounted() {
    if (this.isAltindafirsat) {
      this.refresh();
      this.pollHandle = setInterval(this.refresh, 5 * 60 * 1000);
    }
  },
  beforeDestroy() {
    if (this.pollHandle) clearInterval(this.pollHandle);
  },
  methods: {
    refresh() {
      if (!this.isAltindafirsat) return;
      this.$store.dispatch('mintAgreements/getNotifications', 1);
    },
    goToPending(notification) {
      this.menu = false;
      const query = { tab: 'pending' };
      if (notification && notification.id) query.agreementId = notification.id;
      if (this.$route.path !== '/mint-agreements' || JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router.push({ path: '/mint-agreements', query }).catch(() => {});
      }
    },
    formatCurrency(v) {
      const n = Number(v) || 0;
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 }).format(n);
    },
    formatDate(v) {
      if (!v) return '—';
      const d = new Date(v);
      const day = d.toLocaleDateString('tr-TR', { weekday: 'short' });
      return `${d.toLocaleDateString('tr-TR')} ${day}`;
    },
    severityColor(s) {
      if (s === 'overdue') return 'red darken-2';
      if (s === 'today') return 'orange darken-2';
      return 'amber darken-3';
    },
    severityIcon(s) {
      if (s === 'overdue') return 'error';
      if (s === 'today') return 'today';
      return 'schedule';
    },
    severityTextClass(s) {
      if (s === 'overdue') return 'red--text text--darken-2 font-weight-bold';
      if (s === 'today') return 'orange--text text--darken-3 font-weight-bold';
      return 'amber--text text--darken-3';
    },
    severityLabel(n) {
      if (n.severity === 'overdue') {
        const d = Math.abs(n.daysUntilDue);
        return `${d} gün gecikti`;
      }
      if (n.severity === 'today') return 'Bugün vadesi';
      if (n.daysUntilDue === 1) return 'Yarın vadesi';
      return `${n.daysUntilDue} gün kaldı`;
    },
  },
};
</script>

<style scoped>
@keyframes bell-shake {
  0%, 70%, 100% { transform: rotate(0deg); }
  76% { transform: rotate(-12deg); }
  82% { transform: rotate(12deg); }
  88% { transform: rotate(-8deg); }
  94% { transform: rotate(8deg); }
}
.bell-pulse {
  animation: bell-shake 3.5s ease-in-out infinite;
  transform-origin: 50% 20%;
}
</style>
